import { Component, ViewChild, ElementRef } from "@angular/core";
import { MediaService } from "../../../services/media.service";
import { MediaResultModel } from "../../../models/MediaResultModel";
import { Router } from "@angular/router";
import { Globals } from "../../../services/globals";
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'upload-component',
  templateUrl: 'upload.component.html',
  styleUrls: ["./upload.component.scss"],
})

export class UploadComponent {
  constructor(private uploadService: MediaService,
    private router: Router,
    public globals: Globals,
    private ngxUiLoaderService: NgxUiLoaderService) {
    // Subscribe to when file is finished uploading
    this.uploadService.onUploadFinished.subscribe({
      next: (event: MediaResultModel) => {
        globals.isUploading = false;
        if (event.isValid
          && event.media
          && event.media.id > 0) {
          this.globals.insperationalRoomId=0;
          // this.router.navigate(['/resizer/', event.media.id]);
          this.router.navigate([`/resizer/${event.media.id}/${0}/${this.globals.insperationalRoomId}`]);
        }
      }
    });
  }

  @ViewChild("fileDropRef", { static: false }) fileDropEl: ElementRef;
  files: any[] = [];

  //globals.isUploading = false;

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.ngxUiLoaderService.start();
    this.prepareFilesList($event);
    this.globals.isUploading = true;
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.ngxUiLoaderService.start();
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    if (this.files[index].progress < 100) {
      return;
    }
    this.files.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
          if (this.files[index].progress >= 100) {
            this.globals.isUploading = false;
          }
        }, 200);
      }
    }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    //for (const item of files) {
    //  item.progress = 0;
    //  this.files.push(item);
    //}
    //this.fileDropEl.nativeElement.value = "";
    ////this.uploadFilesSimulator(0);

    if (files.length === 0) return;
    const file = files[0];
    this.globals.isUploading = true;
    this.uploadService.uploadFile(file);
    this.clearfileName();
  }
  clearfileName() {
    this.fileDropEl.nativeElement.value = null;
  }
  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
}
